import type { SearchTrade } from 'lib/sdks/search';

type TradesForCurrentPage = {
  items: SearchTrade[];
  currentPage?: number;
  itemsPerPage?: number;
};

export const getTradesForCurrentPage = ({
  items,
  currentPage = 0,
  itemsPerPage = 0,
}: TradesForCurrentPage) => {
  if (currentPage && currentPage > 1 && items.length > itemsPerPage) {
    const indexUpToEndOfPreviousPage = (currentPage - 1) * itemsPerPage;
    return items.slice(indexUpToEndOfPreviousPage);
  }

  // no results, first page
  return items;
};
